"use client";

import { RelationshipDialog } from "@/components/relationship-dialog";
import { useRelationshipSelection } from "@/hooks/use-relationship-selection";

export function RelationshipSelectionWrapper() {
	const { shouldShowSelection, markSelectionShown, hideSelection } = useRelationshipSelection();

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const handleComplete = (relationship: "buyer" | "seller") => {
		markSelectionShown();
		// Could add additional logic here like redirecting based on relationship
	};

	const handleClose = () => {
		markSelectionShown(); // Mark as shown even if they close without selecting
		hideSelection();
	};

	return (
		<RelationshipDialog
			isOpen={shouldShowSelection}
			onClose={handleClose}
			onComplete={handleComplete}
			mode="selection"
		/>
	);
}
